import React, { useEffect, useState } from "react";
import { Button, Table, Icon } from "semantic-ui-react";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";

import { DateTimeWithoutYear } from "utilities/dist/invoice/constants";

import { loadFintechSyncLogs, syncFintechInvoices } from "../actions";
import { parseServerTimestampForClient } from "../../common/helpers";

export const FintechComponentSyncHistory = ({ invoiceId }) => {
    const dispatch = useDispatch();
    const [showFullLog, setShowFullLog] = useState(false);

    const syncLog = useSelector(({ fintechSyncLog }) => {
        return {
            data: fintechSyncLog.syncLogs[invoiceId] || [],
            isLoading: fintechSyncLog.isLoading[invoiceId] || false,
            error: fintechSyncLog.errors[invoiceId] || false,
        };
    });

    useEffect(() => {
        // Don't reload if we have data for an invoiceId
        // This is because we don't store these in localstorage so when user reloads the page, it will reload anyways
        if (!syncLog.data.length) {
            dispatch(loadFintechSyncLogs([invoiceId]));
        }
    }, [invoiceId]);

    const syncedAtLeastOnce = !!syncLog.data?.find(logRow => {
        if (!logRow.success_log) return false;
        const logDetails = JSON.parse(logRow.success_log);
        return logDetails.step === "end" && logDetails.message === "Sync succeeded";
    });
    const cantSync = syncLog.isLoading || syncedAtLeastOnce;

    //     TODO: use REDUX store for log state
    return (
        <Table striped className="no-print">
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowFullLog(current => !current)}
                    >
                        Fintech Sync History
                        <Icon name={showFullLog ? "chevron up" : "chevron down"} />
                    </Table.HeaderCell>
                    <Table.HeaderCell colSpan="2" textAlign="right">
                        <Button
                            basic
                            type="button"
                            compact={true}
                            color={"green"}
                            loading={syncLog.isLoading}
                            onClick={() => dispatch(syncFintechInvoices([invoiceId]))}
                            disabled={cantSync}
                        >
                            <Icon name="refresh" />
                            Sync Now
                        </Button>
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>

            {syncLog.data.length > 0 && (
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Status</Table.HeaderCell>
                        <Table.HeaderCell textAlign="right">Timestamp</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
            )}

            <Table.Body>
                {!syncLog.data.length ? (
                    <Table.Row>
                        <Table.Cell colSpan="2">
                            This invoice has not been synced with fintech
                        </Table.Cell>
                    </Table.Row>
                ) : (
                    syncLog.data.map(logRow => {
                        const logDetails = logRow.error_log
                            ? JSON.parse(logRow.error_log)
                            : logRow.success_log
                            ? JSON.parse(logRow.success_log)
                            : null;

                        if (!showFullLog && logDetails?.step !== "end") {
                            return null;
                        }

                        return (
                            <Table.Row key={`${logRow.id}`}>
                                <Table.Cell>
                                    <Icon
                                        color={logRow.success_log ? "green" : "red"}
                                        name={logRow.success_log ? "check" : "error"}
                                    />
                                    {logDetails?.message || logDetails?.info?.message}
                                </Table.Cell>
                                <Table.Cell textAlign="right">
                                    {format(
                                        parseServerTimestampForClient(logRow.createdAt),
                                        DateTimeWithoutYear
                                    )}
                                </Table.Cell>
                            </Table.Row>
                        );
                    })
                )}
            </Table.Body>
        </Table>
    );
};
